export const dispatchEvent = (eventName, data = {}) => {
  if (typeof window !== 'undefined') {
    const event = new CustomEvent(eventName, { detail: data });
    window.dispatchEvent(event);
  }
};
